export default "__VITE_ASSET__a955d1bf__"